export enum TipoDestinatarioEnum {
  DIRETTO = <any>"DIRETTO",
  PER_CONOSCENZA = <any>"PER_CONOSCENZA",
}
